import { defineMessages } from 'react-intl';

export const messages: {
    connectSuccessTitle: {
        id: string;
        defaultMessage: string;
        description: string;
    }; connectSuccessDescription: {
        id: string;
        defaultMessage: string;
        description: string;
    }; connectErrorTitle: {
        id: string;
        defaultMessage: string;
        description: string;
    }; connectErrorDescription: {
        id: string;
        defaultMessage: string;
        description: string;
    }; connectButtonLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; connectedButtonLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; usedByLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; recommendedAppsHeading: {
        id: string;
        defaultMessage: string;
        description: string;
    }; loadConnectorsError: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	connectSuccessTitle: {
		id: 'twg-microsite.appCard.connectSuccessTitle',
		defaultMessage: 'Connected successfully',
		description: 'Title for the success flag shown when a connector is connected',
	},
	connectSuccessDescription: {
		id: 'twg-microsite.appCard.connectSuccessDescription',
		defaultMessage: '{appName} has been connected to your account.',
		description:
			'Description for the success flag shown when a connector is connected. {appName} is the name of the third-party app.',
	},
	connectErrorTitle: {
		id: 'twg-microsite.appCard.connectErrorTitle',
		defaultMessage: 'Connection failed',
		description: 'Title for the error flag shown when a connector fails to connect',
	},
	connectErrorDescription: {
		id: 'twg-microsite.appCard.connectErrorDescription',
		defaultMessage: 'Failed to connect {appName}. Please try again.',
		description:
			'Description for the error flag shown when a connector fails to connect. {appName} is the name of the third-party app.',
	},
	connectButtonLabel: {
		id: 'twg-microsite.appCard.connectButtonLabel',
		defaultMessage: 'Connect',
		description: 'Button label to connect a third-party app',
	},
	connectedButtonLabel: {
		id: 'twg-microsite.appCard.connectedButtonLabel',
		defaultMessage: 'Connected',
		description: 'Button label shown when a third-party app is already connected',
	},
	usedByLabel: {
		id: 'twg-microsite.appCard.usedByLabel',
		defaultMessage: 'Used by Luna, Brian and 95 others',
		description: 'Label showing which teammates are using the app',
	},
	recommendedAppsHeading: {
		id: 'twg-microsite.recommendedApps.heading',
		defaultMessage: 'Keep building your graph',
		description: 'Heading for the recommended apps section',
	},
	loadConnectorsError: {
		id: 'twg-microsite.authConnectors.loadConnectorsError',
		defaultMessage: 'Error loading connectors: {error}',
		description:
			'Error message shown when the list of connectors fails to load. {error} is the error description.',
	},
});
